export const news = [
  {
    id: 'news-1',
    title: '2025年暑期档电影市场前瞻：多部大片蓄势待发',
    cover: 'https://readdy.ai/api/search-image?query=cinema%20hall%20interior%20with%20rows%20of%20red%20seats%20and%20large%20glowing%20screen%2C%20warm%20ambient%20lighting%2C%20anticipatory%20atmosphere%2C%20cinematic%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-01&orientation=landscape',
    date: '2025-06-18',
    category: '市场前瞻',
    summary:
      '随着暑期档临近，多部备受期待的影片陆续官宣定档。从科幻巨制到温情家庭片，类型丰富、阵容强大，市场表现值得期待。',
    content: [
      '随着暑期档的临近，今年的电影市场正在迎来一年中最热闹的时段。据不完全统计，目前已有十余部中外影片确定在六至八月期间上映，题材涵盖科幻、动作、动画、家庭等多个类型，为观众提供了丰富的观影选择。',
      '从已公布的档期来看，科幻题材依旧是今年暑期档的主力。《星际远航》凭借宏大的世界观与精良的特效制作，被视为档期内最受关注的作品之一。与此同时，多部国产动画电影也瞄准了亲子观影群体，试图在合家欢赛道上分得一杯羹。',
      '业内人士分析认为，随着观众观影习惯的日益成熟，单纯依靠明星阵容已难以保障票房，内容质量与口碑传播将成为决定影片成败的关键因素。多部影片纷纷加大在剧本打磨与制作环节的投入，力求在激烈的市场竞争中脱颖而出。',
      '此外，影院端的服务升级也在同步进行。多家院线推出了差异化的影厅体验与会员权益，希望借此提升观众的到店意愿。可以预见，今年的暑期档将是一场内容与服务的双重较量。'
    ],
    relatedIds: ['movie-1', 'movie-9', 'movie-6']
  },
  {
    id: 'news-2',
    title: '《星际远航》口碑爆棚，科幻题材再掀热潮',
    cover: 'https://readdy.ai/api/search-image?query=deep%20space%20nebula%20with%20distant%20stars%2C%20lone%20spaceship%20silhouette%2C%20vast%20cosmic%20wonder%2C%20deep%20blue%20and%20violet%20nebulae%2C%20epic%20cinematic%20atmosphere%2C%20no%20text&width=800&height=450&seq=news-cover-02&orientation=landscape',
    date: '2025-06-12',
    category: '影片评论',
    summary:
      '上映首周，《星际远航》便收获大量好评，观众对其世界观构建与情感表达给予高度评价，科幻类型再度成为热议焦点。',
    content: [
      '自上映以来，《星际远航》迅速成为社交平台上的热门话题。影片以一支深空探索舰队的旅程为主线，将硬核的科幻设定与细腻的人物情感巧妙融合，赢得了观众的广泛认可。',
      '不少观众表示，影片最打动人的并非炫目的特效，而是船员们在绝境中展现出的信任与牺牲。导演在处理宏大叙事与个体情感之间的平衡时，展现出了成熟的掌控力。',
      '影评人指出，近年来国产科幻作品在视听呈现上进步显著，而《星际远航》则进一步在故事内核上做出了有益的探索。这种"技术为叙事服务"的创作思路，或将为后续同类作品提供参考。',
      '随着口碑的持续发酵，影片的排片占比也稳步上升。有分析认为，良好的长线口碑有望帮助其取得超出预期的票房成绩。'
    ],
    relatedIds: ['movie-1', 'movie-6']
  },
  {
    id: 'news-3',
    title: '国产剧集出海成绩亮眼，多部作品登陆海外平台',
    cover: 'https://readdy.ai/api/search-image?query=global%20streaming%20concept%20with%20world%20map%20and%20glowing%20connection%20lines%2C%20modern%20digital%20devices%20on%20a%20desk%2C%20cool%20blue%20and%20warm%20accent%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-03&orientation=landscape',
    date: '2025-05-29',
    category: '行业观察',
    summary:
      '越来越多国产剧集通过海外流媒体平台走向世界，古装、悬疑与都市题材表现尤为突出，文化输出成效逐步显现。',
    content: [
      '近年来，国产剧集的海外传播力度不断增强。据相关统计，今年已有数十部国产剧集在海外主流流媒体平台上线，覆盖多个国家和地区，其中古装、悬疑与都市题材最受欢迎。',
      '《长安风云录》等历史题材作品凭借精良的制作与东方美学，在海外观众中收获了不少好评。而《迷雾侦探》《破案笔记》一类强情节剧集，则依靠紧凑的叙事节奏吸引了大量国际观众。',
      '业内人士表示，国产剧集出海已从早期的"单点突破"进入"规模化输出"阶段。除了内容本身的质量提升，字幕翻译、本地化运营与海外发行渠道的完善，都为这一进程提供了有力支撑。',
      '不过，如何在不同文化语境下讲好故事、避免水土不服，仍是国产剧集走向世界需要长期面对的课题。'
    ],
    relatedIds: ['tv-1', 'tv-3', 'tv-9']
  },
  {
    id: 'news-4',
    title: '影视行业观察：短剧崛起对传统剧集的冲击与启示',
    cover: 'https://readdy.ai/api/search-image?query=mobile%20phone%20playing%20short%20vertical%20videos%2C%20modern%20studio%20desk%2C%20neon%20accent%20lighting%2C%20digital%20media%20concept%2C%20contemporary%20atmosphere%2C%20no%20text&width=800&height=450&seq=news-cover-04&orientation=landscape',
    date: '2025-05-14',
    category: '行业观察',
    summary:
      '短剧凭借快节奏与强共鸣迅速占领用户碎片时间，传统剧集面临新的竞争，也从中获得了创作节奏上的启示。',
    content: [
      '近两年，短剧市场迎来爆发式增长。单集时长几分钟、剧情高度浓缩的作品，凭借极低的观看门槛和强烈的情绪共鸣，迅速渗透进用户的日常生活。',
      '短剧的走红，对传统长剧集造成了一定的分流压力。观众的注意力变得更加稀缺，前几集甚至前几分钟能否抓住人，成为决定一部剧成败的重要关卡。',
      '面对变化，不少传统剧集也开始调整创作思路：加快前期节奏、强化角色塑造、更加注重"钩子"的设置。有编剧坦言，短剧在叙事效率上的优势，值得长剧创作者认真研究。',
      '当然，短剧与长剧并非简单的替代关系。长剧在人物弧光、世界观铺陈与情感沉淀上仍具备不可替代的价值。二者更可能在各自的赛道上相互借鉴、共同成长。'
    ],
    relatedIds: ['tv-2', 'tv-6']
  },
  {
    id: 'news-5',
    title: '经典IP翻拍热潮：是情怀回归还是创意枯竭',
    cover: 'https://readdy.ai/api/search-image?query=stack%20of%20vintage%20film%20reels%20and%20old%20projector%2C%20warm%20nostalgic%20lighting%2C%20retro%20cinema%20atmosphere%2C%20sepia%20and%20amber%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-05&orientation=landscape',
    date: '2025-04-30',
    category: '深度解读',
    summary:
      '多部经典影视作品陆续宣布翻拍，引发观众期待与质疑并存。翻拍究竟是对情怀的致敬，还是原创力不足的表现？',
    content: [
      '经典IP翻拍，正在成为当下影视市场的一股重要潮流。从武侠到家庭剧，从动画到悬疑，众多曾经陪伴一代人成长的作品被重新搬上荧幕。',
      '支持者认为，翻拍让年轻观众有机会接触到经典故事，也让优秀的老作品以全新的技术手段焕发生机。只要尊重原作精神、用心打磨，翻拍同样能够成就佳作。',
      '而质疑的声音则指出，部分翻拍作品缺乏诚意，仅在形式上做简单复制，既没有超越原作，也未能提供新的视角，最终沦为"炒冷饭"。',
      '业内普遍认为，翻拍的关键不在于"是否该拍"，而在于"如何拍好"。真正成功的翻拍，应当在与原作对话的基础上，表达属于这个时代的思考。'
    ],
    relatedIds: ['movie-8', 'tv-1']
  },
  {
    id: 'news-6',
    title: '盘点年度十部高分剧集，你追了几部',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20TV%20screens%20showing%20various%20shows%2C%20warm%20evening%20light%2C%20binge%20watching%20concept%2C%20inviting%20yellow%20and%20teal%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-06&orientation=landscape',
    date: '2025-04-16',
    category: '榜单盘点',
    summary:
      '过去一年里，一批兼具口碑与热度的剧集脱颖而出。本文为你梳理其中十部最受好评的作品，看看你都追过哪些。',
    content: [
      '回望过去一年，剧集市场亮点纷呈。从权谋正剧到治愈爱情，从硬核悬疑到青春成长，各类题材都涌现出不少值得一看的佳作。',
      '其中，《权力之巅》凭借犀利的对白与对人性深刻的描绘，稳居口碑榜前列；《迷雾侦探》则以精巧的单元案件结构收获了大批忠实观众；而《山间人家》用质朴的镜头语言，讲述了中国家庭的温情故事。',
      '此外，《破案笔记》《长安风云录》等作品也凭借扎实的制作赢得认可。这些剧集的共同点在于：尊重观众的智商，注重人物的真实性，并且敢于在题材与表达上做出尝试。',
      '对于观众而言，这份榜单或许只是一个参考。真正的好剧，往往需要自己去发现。希望你能在这些作品里，找到属于自己的那一部。'
    ],
    relatedIds: ['tv-6', 'tv-3', 'tv-7', 'tv-9']
  },
  {
    id: 'news-7',
    title: '动画电影市场持续升温，合家欢题材受青睐',
    cover: 'https://readdy.ai/api/search-image?query=colorful%20animated%20movie%20concept%20art%2C%20whimsical%20fantasy%20landscape%20with%20floating%20islands%2C%20bright%20pastel%20sky%2C%20joyful%20magical%20atmosphere%2C%20no%20text&width=800&height=450&seq=news-cover-07&orientation=landscape',
    date: '2025-03-27',
    category: '市场前瞻',
    summary:
      '动画电影近年来持续升温，兼具艺术性与娱乐性的合家欢作品尤其受到市场欢迎，成为票房增长的重要引擎。',
    content: [
      '动画电影正在成为电影市场中一股不容忽视的力量。无论是面向低龄观众的亲子动画，还是吸引全年龄段的成人向作品，都在票房与口碑上取得了不俗表现。',
      '《天空之城日记》等作品的火爆，印证了合家欢题材的市场潜力。这类影片既能满足孩子对奇幻世界的想象，也能让陪伴观影的家长获得情感共鸣，实现了家庭观影场景的"通吃"。',
      '业内分析指出，动画电影的成功并非偶然。一方面得益于技术手段的进步，画面表现力不断提升；另一方面则源于创作者对故事与情感内核的重视——毕竟，能打动人心的，永远是好的故事。',
      '随着越来越多创作者投身动画领域，这一市场有望在未来持续扩容，为观众带来更多兼具想象力与温度的作品。'
    ],
    relatedIds: ['movie-9', 'movie-5']
  },
  {
    id: 'news-8',
    title: '影视配乐专题：那些让人难忘的经典旋律',
    cover: 'https://readdy.ai/api/search-image?query=orchestra%20recording%20session%20in%20a%20dim%20studio%2C%20musicians%20with%20instruments%2C%20warm%20spotlight%2C%20expressive%20emotional%20atmosphere%2C%20amber%20tones%2C%20no%20text&width=800&height=450&seq=news-cover-08&orientation=landscape',
    date: '2025-03-11',
    category: '深度解读',
    summary:
      '优秀的影视配乐能让观众在画面之外，久久无法忘怀。本文带你重温那些与经典影视作品相伴的难忘旋律。',
    content: [
      '如果说画面是影视作品的眼睛，那么配乐就是它的呼吸。一段恰到好处的旋律，往往能在瞬间将观众带入故事的情绪之中。',
      '许多经典影视作品之所以令人难忘，与其出色的配乐密不可分。无论是恢弘的史诗主题，还是低回婉转的抒情段落，音乐都在无声处完成了对叙事的升华。',
      '好的配乐从不喧宾夺主。它懂得在恰当的时机出现，又能在需要留白时悄然退场。这种克制与精准，正是影视配乐创作的难点所在。',
      '对于创作者而言，理解故事的情感内核，往往是写出动人旋律的前提。当音乐与画面、与人物真正融为一体时，经典便由此诞生。'
    ],
    relatedIds: ['movie-5', 'movie-10', 'tv-6']
  }
];